import { createBucketClient } from "@cosmicjs/sdk";

const BUCKET_SLUG = process.env.NEXT_PUBLIC_COSMIC_BUCKET_BLOG_SLUG;
const READ_KEY = process.env.NEXT_PUBLIC_COSMIC_READ_BLOG_KEY;

const bucket = createBucketClient({
  bucketSlug: BUCKET_SLUG,
  readKey: READ_KEY,
});

const objectType = 'blog';
const is404 = (error) => /not found/i.test(error.message);

export async function getAllBlogSlug() {
  const params = {
    type: objectType,
  };

  try {
    const data = await bucket.objects.find(params).props('slug,metadata');
    return data.objects.map((object) => ({
      slug: object.slug,
      locale: object.metadata.linguagem_do_post.key
    }));
  } catch (e) {
    if (is404(e)) return;
    console.error(e);
  }
}

export async function getPostAndMorePosts(slug, locale = 'pt') {
  const defaultPropsForCms = "slug,title,metadata,created_at";

  const singleObjectParams = {
    type: objectType,
    slug,
    'metadata.linguagem_do_post': locale
  };

  const moreObjectParams = {
    type: objectType,
    'metadata.linguagem_do_post': locale
  };

  try {
    const object = await bucket.objects.find(singleObjectParams).props(defaultPropsForCms);
    const moreObjects = await bucket.objects.find(moreObjectParams).props(defaultPropsForCms).limit(3);

    const morePosts = moreObjects.objects?.filter(
      ({ slug: object_slug }) => object_slug !== slug
    )

    return {
      post: object.objects[0],
      morePosts,
    };
  } catch (e) {
    // Don't throw if an slug doesn't exist
    if (is404(e)) return;
    console.error(e);
  }
}

export async function getLastPost(locale = 'pt') {
  const defaultPropsForCms = "slug,title,metadata,created_at";

  const singleObjectParams = {
    type: objectType,
    sort: '-created_at',
    "metadata.linguagem_do_post": locale
  };

  try {
    const post = await bucket.objects.findOne(singleObjectParams).props(defaultPropsForCms);
    return post.object;
  } catch (e) {
    // Don't throw if an slug doesn't exist
    if (is404(e)) return;
    console.error(e);
  }
}

export async function getPaginatedPosts(params = { limit: 5, search: '', page: 1, locale: 'pt' }) {
  const defaultPropsForCms = "slug,title,metadata,created_at";

  const moreObjectParams = {
    type: objectType,
    sort: '-created_at',
    ...(params.search && {
        title: {
          $regex: `.*${params.search}.*`,
          $options: 'i'
        }
    }),
    ...(params.locale && {
      'metadata.linguagem_do_post': params.locale
    })
  };

  try {
    const response = await bucket.objects
      .find(moreObjectParams)
      .props(defaultPropsForCms)
      .skip(params.limit * (params.page - 1))
      .limit(params?.limit);
    return {
      total: response.total,
      posts: response.objects
    };
  } catch (e) {
    // Don't throw if an slug doesn't exist
    if (is404(e)) return
    console.error(e);
  }
}

export async function getBlogPostsToGenerate() {
  try {
    // Verifica se está em ambiente de CI (Bitbucket)
    const isCI = process.env.CI === 'true';
    console.log('🔍 Ambiente de build:', isCI ? 'CI (Bitbucket)' : 'Local');
    
    if (!isCI) {
      console.log('📝 Gerando posts localmente');
      const allPosts = await getAllBlogSlug();
      return allPosts;
    }

    // Determina o environment baseado no branch do Bitbucket
    const environment = process.env.BITBUCKET_BRANCH?.toLowerCase() === 'master' ? 'production' : 'development';
    console.log('🌍 Environment:', environment);
    console.log('🔄 Buscando posts para gerar via API');

    const response = await fetch(`${process.env.NEXT_PUBLIC_VERZEL_LAMBDA_FUNCTIONS_HOST}/blog/posts-to-generate?environment=${environment}`, {
      method: 'GET',
      headers: {
        'content-type': 'application/json',
        'X-Api-Key': process.env.NEXT_PUBLIC_VERZEL_LAMBDA_FUNCTIONS_KEY,
      },
    });

    if (!response.ok) { 
      console.error('❌ Erro ao buscar posts via API');
      throw new Error('Failed to fetch posts to generate');
    }

    const data = await response.json();
    console.log('✅ Posts obtidos com sucesso via API');

    console.log('🔄 Posts obtidos:', data.result.pathsToGenerate.length);
    return data.result.pathsToGenerate;
  } catch (error) {
    console.error('⚠️ Erro no processo:', error.message);
    console.log('🔄 Fallback: buscando todos os posts localmente');
    const allPosts = await getAllBlogSlug();
    return allPosts;
  }
}
